import { connectCore } from "core/core";
import navhelper from "core/navhelper";
import AdminHomeScreen from "./screens/AdminHomeScreen";
import ChatScreen from "./screens/ChatScreen";
import EmergencyScreen from "./screens/EmergencyScreen";
import FinishSetupScreen from "./screens/FinishSetupScreen";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import RecruitmentScreen from "./screens/RecruitmentScreen";
import ResetPasswordScreen from "./screens/ResetPasswordScreen";
import SignupScreen from "./screens/SignupScreen";
import SplashScreen from "./screens/SplashScreen";
import SubscriptionScreen from "./screens/SubscriptionScreen";
import UserDetailsScreen from "./screens/UserDetailsScreen";
import UserProfileScreen from "./screens/UserProfileScreen";
import UserTimeOffRequest from "./screens/UserTimeOffRequest";
import AdminEditUserProfileScreen from "./screens/AdminEditUserProfileScreen";
import VerifyEmailScreen from "./screens/VerifyEmailScreen";
import WelcomeScreen from "./screens/WelcomeScreen";
import AdminProfileScreen from "./screens/admin/AdminProfileScreen";
import AdminTimeOffScreen from "./screens/admin/AdminTimeOffScreen";
import AdminWelcomeScreen from "./screens/admin/AdminWelcomeScreen";
import ProfDetailsScreen from "./screens/consumer/ProfDetailsScreen";
import ProfFeedbacksScreen from "./screens/consumer/ProfFeedbacks";
import ProfileScreen from "./screens/consumer/ProfileScreen";
import QuestionaireInfoScreen from "./screens/consumer/QuestionaireInfoScreen";
import AppRatingScreen from "./screens/consumer/Ratings/AppRatingScreen";
import ScheduleCallScreen from "./screens/consumer/ScheduleCallScreen";
import SubscriptionInfoScreen from "./screens/consumer/SubscriptionInfoScreen";
import SupportScreen from "./screens/consumer/SupportScreen";
import Chat from "./screens/consumer/tabs/Chat";
import TwilioVideoCall from "./screens/consumer/tabs/Chat/TwilioVideoCall";
import Home from "./screens/consumer/tabs/Home";
import Menu from "./screens/consumer/tabs/Menu";
import LiveAgentScreen from "./screens/consumer/tabs/Menu/LiveAgent/LiveAgentScreen";
import ManageSubscriptionsScreen from "./screens/consumer/tabs/Menu/ManageSubscriptionsScreen";
import StripeScreen from "./screens/consumer/tabs/Menu/ManageSubscriptionsScreen/StripeScreen";
import AvailabilityScreen from "./screens/provider/AvailabilityScreen";
import AwaitingVerificationScreen from "./screens/provider/AwaitingVerificationScreen";
import ProFinishSetupScreen from "./screens/provider/ProFinishSetupScreen";
import ProScheduleCallScreen from "./screens/provider/ProScheduleCallScreen";
import ProSignupScreen from "./screens/provider/ProSignupScreen";
import ProAppointments from "./screens/provider/ProTabs/ProAppointments";
import ProChat from "./screens/provider/ProTabs/ProChat";
import ProClientInteraction from "./screens/provider/ProTabs/ProChat/ProClientInteraction";
import ProIndividualChat from "./screens/provider/ProTabs/ProChat/ProIndividualChat";
import ProHome from "./screens/provider/ProTabs/ProHome";
import ProMenu from "./screens/provider/ProTabs/ProMenu/ProMenu";
import ProUpdateScreen from "./screens/provider/ProUpdateScreen";
import ProVerifyEmailScreen from "./screens/provider/ProVerifyEmailScreen";
import ProWelcomeScreen from "./screens/provider/ProWelcomeScreen";
import UserDetailReportScreen from "./screens/reports/UserDetailReportScreen";
import UserChatScreen from "./screens/UserChatScreen";
import UserSettingScreen from "./screens/UserSettingScreen";
import ProjectScreen from "./screens/ProjectScreen";
import TeamAvailability from "./screens/TeamAvailability";
import AdminQuestionnaireScreen from "./screens/admin/AdminQuestionnaireScreen";
import ReviewAssignmentScreen from "./screens/ReviewAssignmentScreen";
import UserReviewScreen from "./screens/UserReviewScreen";
import ReviewSubmissionScreen from "./screens/ReviewSubmissionScreen";
import AdminReviewsScreen from "./screens/admin/AdminReviewsScreen";
import SubmittedReviewScreen from "./screens/admin/SubmittedReviewScreen";
export function registerScreens(){
 
navhelper.registerScreens({
    default:SplashScreen,//WebViewTest,
    portal:SplashScreen,
    WelcomeScreen,
    UserReviewScreen,
    ReviewSubmissionScreen,
    ReviewAssignmentScreen,
    LoginScreen,
    HomeScreen,
    RecruitmentScreen,
    TeamAvailability,
    SignupScreen,
    FinishSetupScreen,
    SubscriptionScreen,
    EmergencyScreen,
    Home,
    Chat,
    Menu,
    ManageSubscriptionsScreen,
    StripeScreen,
    TwilioVideoCall,
    ProfDetailsScreen,
    ProfFeedbacksScreen,
    ScheduleCallScreen,
    ChatScreen,
    VerifyEmailScreen,
    AdminEditUserProfileScreen,
    ProfileScreen,
    ResetPasswordScreen,
    SupportScreen,
    SubscriptionInfoScreen,
    QuestionaireInfoScreen,
    AppRatingScreen,
    LiveAgentScreen,
    UserProfileScreen,
    UserTimeOffRequest,
    UserDetailsScreen,
    UserDetailReportScreen,
    UserChatScreen,
    UserSettingScreen,
    ProjectScreen,
    //provider screens
    ProWelcomeScreen,
    ProSignupScreen,
    ProVerifyEmailScreen,
    ProFinishSetupScreen,
    AwaitingVerificationScreen,
    ProUpdateScreen,
    AvailabilityScreen,
    ProHome,
    ProChat,
    ProMenu,
    ProAppointments,
    ProIndividualChat,
    ProClientInteraction,
    ProScheduleCallScreen,
    SubmittedReviewScreen,
    
    //admin screens
    AdminWelcomeScreen,
    AdminHomeScreen,
    AdminProfileScreen,
    AdminTimeOffScreen,
    AdminQuestionnaireScreen,
    AdminReviewsScreen,
  },
  connectCore)
}